<header class="background-header">
    <img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img"
        [ngClass]="{backgroundWidth: themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
    <section class="navbar-brand navbar-brand-choose-plan">
        <img class="main-logo" src="../../assets/img/{{themeService.theme}}/main-logo.png"
            alt="Company Logo" width="125px">
    </section>
</header>
<header class="mobile-header">
    <img src="../../assets/img/{{themeService.theme}}/main-logo.png" alt="Company Logo" width="125px">
</header>

<section class="main-side-nav"
    [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
    <section class="container security-page-sign-up-container dynamic-collapse-top" id="securityPageSignUpContainer">
        <section class="dynamic-collapse">
            <section class="dynamic-collapse-header" data-bs-toggle="collapse" data-bs-target="#example1">
                <h1 class="col">How we keep your plan secure</h1>
            </section>
            <section class="dynamic-collapse-main">
                <div class="dynamic-collapse-content">
                    <div class="content">
                        We are committed to protecting all of the data in your plan with best-in-class security. The
                        information that you choose to store in your plan is end-to-end encrypted, meaning it can only
                        be
                        accessed by you and the people that you choose to share it with.
                    </div>
                    <div class="boxes">
                        <div class="box">
                            <div class="header">
                                <img src="../../assets/img/{{themeService.theme}}/encrypt-data-transit.svg" alt="">
                                <div class="title">Encrypted in transit</div>
                            </div>
                            <div class="main">
                                TLS encryption ensures no one can intercept your data as it travels between our secure
                                servers and your device.
                            </div>
                        </div>
                        <div class="box">
                            <div class="header">
                                <img src="../../assets/img/{{themeService.theme}}/encrypt-data-rest.svg" alt="">
                                <div class="title">Encrypted at rest</div>
                            </div>
                            <div class="main">
                                All of the data in your plan is securely stored and backed-up on encrypted disks in
                                ISO27001 certified data centres.
                            </div>
                        </div>
                        <div class="box">
                            <div class="header">
                                <img src="../../assets/img/{{themeService.theme}}/multi-factor-authentication.svg"
                                    alt="">
                                <div class="title">Two-factor authentication</div>
                            </div>
                            <div class="main">
                                An extra layer of security requiring a verification code, along with your password, for
                                yo u to access your plan.
                            </div>
                        </div>
                        <div class="box">
                            <div class="header">
                                <img src="../../assets/img/{{themeService.theme}}/operational-process-security.svg"
                                    alt="">
                                <div class="title">Independent testing</div>
                            </div>
                            <div class="main">
                                Our system is regularly tested by certified cyber security experts, ensuring your data
                                is protected from the latest threats.
                            </div>
                        </div>

                    </div>
                    <div class="next-button">
                        <input class="btn btn-primary primary-default-btn next-btn" (click)="goTo()" type="submit"
                            value="Continue" />
                    </div>
                </div>
            </section>
        </section>
    </section>
</section>